import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import authReducer from './slices/authSlice';
import bookingReducer from './slices/bookingSlice';
import notificationReducer from './slices/notificationSlice';
import uiReducer from './slices/uiSlice'; // <--- ADD THIS
import { apiSlice } from './api/apiSlice';

// 1. Configuration for Redux Persist
const persistConfig = {
  key: 'root',
  storage,
  // Persist auth and ui (preferences)
  whitelist: ['auth', 'ui'],
};

// 2. Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  booking: bookingReducer,
  notification: notificationReducer,
  ui: uiReducer, // <--- ADD THIS
  [apiSlice.reducerPath]: apiSlice.reducer,
});

// 3. Create a persisted reducer wrapper
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  // 4. Middleware to ignore redux-persist action types in the console warnings
  // AND add RTK Query middleware
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(apiSlice.middleware),
});

// 5. Create a persistor object
export const persistor = persistStore(store);

// NOTE: You must now wrap your main App component with <PersistGate loading={null} persistor={persistor}>